// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "org.arianee",
    name: "Arianee Wallet",
    homepage: "https://arianee.org",
    image_id: "ace938a9-c906-4b9e-f683-b85f1ab72800",
    app: {
        browser: null,
        ios: "https://apps.apple.com/fr/app/arianee-wallet/id1435782507",
        android: "https://play.google.com/store/apps/details?id=com.arianee.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "com.arianee.wallet://",
        universal: "https://arianee.net",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map